import { Component, OnInit, Input } from "@angular/core";
import { Router } from "@angular/router";
import { ActivatedRoute } from "@angular/router";
import { DataService } from "../data.service";
import { FormBuilder } from "@angular/forms";

@Component({
  selector: "app-reporttypes",
  templateUrl: "./reporttypes.component.html",
  styleUrls: ["./reporttypes.component.scss"],
})
export class ReporttypesComponent implements OnInit {
  isLoading = false;
  isError = false;
  errorMessage = "";
  reportTypes = [];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private dataService: DataService,
    private _router: Router
  ) {}

  ngOnInit() {
    this.getReportType();
  }

  displayedColumns: string[] = [
    "id",
    "label",
    "description",
    "category",
    "deployed",
    "createddate",
    "modifiedby",
    "modifieddate",

  ];
  dataSource: any;

  newReportType() {
    this.router.navigateByUrl("home/reporttype/new");
  }

  getReportType() {
    // alert(id)
    const organizationid = localStorage.getItem("crm_orgid");
    // const domain = localStorage.getItem("domain");
    // const subdomain = localStorage.getItem("subdomain");
    const domain= localStorage.getItem(`${localStorage.getItem("crm_orgid")}.domain`);
    const subdomain= localStorage.getItem(`${localStorage.getItem("crm_orgid")}.subdomain`);

    this.isLoading = true;
    this.dataService.getReportTypes(organizationid,domain,subdomain).subscribe(
      (res) => {
        // alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          // alert("Are you sure?")
          // this.router.navigate(['home/globalaction'])
          // window.location.reload();
          this.reportTypes = res.data.reporttype;
          if (this.reportTypes != null) {
            this.dataSource = this.reportTypes.map((reporttype) => ({
              id: reporttype.id,
              label: reporttype.labelname,
              description: reporttype.description,
              category: reporttype.category,
              deployed: reporttype.deployed,
              createddate: reporttype.createddate,
              modifiedby: reporttype.modifiedby,
              modifieddate: reporttype.modifieddate,

            }));
          }
          this.isLoading = false;
        } else {
          console.log("error in getting data");
          this.isLoading = false;
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.errorMessage = err.message;
        this.isError = true;
        this.isLoading = false;
      }
    );
  }

  delete(id: number) {
    // alert(id)
    const organizationid = localStorage.getItem("crm_orgid");
    const domain = localStorage.getItem(`${localStorage.getItem("crm_orgid")}.domain`);
    const subdomain = localStorage.getItem(`${localStorage.getItem("crm_orgid")}.subdomain`);
    const confirmDelete = window.confirm("Are you sure you want to delete?");

    if (!confirmDelete) {
      return;
    }

    this.isLoading = true;
    this.dataService.deleteReportType(organizationid,domain,subdomain, id).subscribe(
      (res) => {
        // alert('****res****' + JSON.stringify(res));
        console.log(res);
        if (res.success == 1) {
          // alert("Are you sure?")
          window.location.reload();

          this.isLoading = false;
        } else {
          console.log("error while deleting");
          this.isLoading = false;
        }
      },
      (err) => {
        console.log("Error***:", err);
        this.errorMessage = err.message;
        this.isError = true;
        this.isLoading = false;
      }
    );
  }
}
